const Sectores =
({    
    checking,
    setChecking,
    codigosSectores,
    setCodigosSectores,
    checkboxesSectores,
    setCheckboxesSectores,
    sectores,
    sorting,
    loading,
    setPagination,
    status422
}) =>
{
    const handleChildCheckbox = (e) =>
    {
        setChecking(true);

        const checked = e.target.checked;
        const sector = e.target.value;

        if (checked === true)
        {
            const sectores = [];

            for (let i = 0; i < codigosSectores.length; i++)
            {
                sectores.push(codigosSectores[i]);
            }

            sectores.push(sector);

            setCodigosSectores(sectores);
        }
        else
        {
            const sectores = codigosSectores.filter(nombre => nombre !== sector);

            setCodigosSectores(sectores);
        }

        setCheckboxesSectores(
            {
                ...checkboxesSectores,
                [sector]: checked
            });

        setPagination(1);
    }

    return (
        <div className="card border-0 mb-1">
            <div className="accordion" id="accordionPanelEspecie">
                <div className="accordion-item">
                    <h5 className="accordion-header"><button className="accordion-button p-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsSectores" aria-expanded="true" aria-controls="panelsSectores">Sectores:</button></h5>
                    <div id="panelsSectores" className="accordion-collapse collapse">
                        <div className="accordion-body">

                            {
                                sectores.map((sector, index) =>
                                (
                                    <div className="row" key={index}>
                                        <div className="col">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`sector-${index}`}
                                                    name="nombre_especie"
                                                    value={sector.SECTOR}
                                                    onChange={handleChildCheckbox}
                                                    checked={Object.hasOwn(checkboxesSectores, `${sector.SECTOR}`) ? checkboxesSectores[`${sector.SECTOR}`] : false}
                                                    disabled={!status422 && (!loading || checking || sorting)}
                                                />
                                                <label className="form-check-label" htmlFor={`sector-${index}`}>{sector.SECTOR}</label>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sectores;
